var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: _vm.loading, "max-width": "926", width: "470" },
      on: {
        input: function ($event) {
          return _vm.setData($event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _vm.isUpdate
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            color: "primary",
                            height: 40,
                            ripple: false,
                            elevation: "0",
                            icon: "",
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mt-1", attrs: { size: "22" } },
                        [_vm._v(" mdi-border-color ")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            height: "40",
                            color: "primary",
                            elevation: "0",
                            ripple: false,
                            rounded: "",
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v(" mdi-plus-circle "),
                      ]),
                      _vm._v(" เพิ่มแบรนด์ "),
                    ],
                    1
                  ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("div", { staticClass: "primary--text title" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.isUpdate ? "แก้ไขแบรนด์" : "เพิ่มแบรนด์") +
                    " "
                ),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "#A9A9A9", "x-small": "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogs()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(" mdi-close "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "mt-4",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit($event)
                    },
                  },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "label",
                    { staticClass: "d-block mb-2", attrs: { for: "name" } },
                    [_vm._v("ชื่อแบรนด์")]
                  ),
                  _c("v-text-field", {
                    attrs: {
                      id: "name",
                      rules: _vm.nameRules,
                      placeholder: "ชื่อแบรนด์",
                      "background-color": "#ffffff",
                      autocomplete: "off",
                      "hide-details": "",
                      autofocus: "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.loading,
                    color: "primary",
                    rounded: "",
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogs()
                    },
                  },
                },
                [_vm._v(" ยกเลิก ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    ripple: false,
                    loading: _vm.loading,
                    disabled: _vm.loading,
                    color: "primary",
                    depressed: "",
                    rounded: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit()
                    },
                  },
                },
                [_vm._v(" ยืนยัน ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }